<div class="callback-container">
  <div class="loading-message">
    <h2>Processing authentication...</h2>
    <p>Please wait while we complete your login.</p>
  </div>
</div>

